<template>
  <div>
    <el-table
      stripe
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-row :gutter="10">
            <el-col :md="6">
              <p><strong>Title: </strong>{{ props.row.title || 'None' }}</p>
              <p><strong>Name: </strong>{{ props.row.name || 'None' }}</p>
              <p><strong>Address: </strong>{{ props.row.address || 'None' }}</p>
            </el-col>
            <el-col :md="6">
              <p><strong>Phone: </strong>{{ props.row.phone || 'None' }}</p>
              <p><strong>Mobile: </strong>{{ props.row.mobile || 'None' }}</p>
              <p><strong>Email: </strong>{{ props.row.email || 'None' }}</p>
            </el-col>
            <el-col :md="6">
              <p><strong>Include Billing: </strong>{{ props.row.include_billing ? 'YES' : 'No' }}</p>
              <p><strong>Include Pickups: </strong>{{ props.row.include_pickups ? 'YES' : 'No' }}</p>
            </el-col>
            <el-col :md="6">
              <p><strong>Notes: </strong></p>
              <p style="background-Color: #F5F5F5; padding: 5px;">
                {{ props.row.notes || 'None' }}
              </p>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column
        label="Filename"
        prop="name"
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />
      <el-table-column
        label="Received At"
        prop="title"
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />
      <el-table-column
        label="Status"
        prop="contact_type"
        :formatter="(row, col, cellValue) => cellValue.long || '-'"
      />
      <el-table-column
        v-if="canUpdate || canDelete"
        label="Actions"
        align="right"
      >
        <template slot-scope="scope">
          <el-button
            v-if="canUpdate"
            size="mini"
            @click.native="editContact(scope.$index, scope.row)"
          >
            Edit
          </el-button>
          <el-button
            v-if="canDelete"
            size="mini"
            type="danger"
            @click.native="deleteContact(scope.$index, scope.row)"
          >
            Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- Pagination -->
    <br>
    <div style="text-align: center;">
      <el-pagination
        :current-page.sync="page"
        :page-size.sync="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="loadTable()"
        @current-change="loadTable()"
      />
    </div>

    <!-- Edit Form -->
    <ContactEditForm
      v-if="isShowEditForm"
      ref="editForm"
      :is-show.sync="isShowEditForm"
      :account-id="accountId"
      :contact="contact"
      @saved="loadTable"
    />
  </div>
</template>

<script>
export default {
  mounted () {
    this.actions = [
      {
        name: 'Create',
        icon: ['fal', 'plus'],
        event: () => {
        }
      },
      {
        name: 'Refresh',
        icon: ['fal', 'sync']
      }
    ]
  },
  methods: {
  }
}
</script>

<style>

</style>
